/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popFaceTip.vue?vue&type=template&id=8d13bacc&scoped=true"
import script from "./popFaceTip.vue?vue&type=script&lang=js"
export * from "./popFaceTip.vue?vue&type=script&lang=js"
import style0 from "./popFaceTip.vue?vue&type=style&index=0&id=8d13bacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d13bacc",
  null
  
)

export default component.exports